module.exports = "image-gallery"